<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
	label?: string;
	status: 'success' | 'pending' | 'error' | 'warning' | 'default';
	iconName?: string;
}>();

const computedClass = computed(() => {
	switch (props.status) {
		case 'success':
			return 'status-badge--success';
		case 'pending':
			return 'status-badge--pending';
		case 'error':
			return 'status-badge--error';
		case 'warning':
			return 'status-badge--warning';
		case 'default':
		default:
			return 'status-badge--default';
	}
});
</script>
<template>
	<span :class="['status-badge', computedClass]">
		<span v-if="iconName" :class="`mr-1 bx ${iconName}`" />{{
			label?.replace('_', ' ').toLowerCase() || 'no available info'
		}}
	</span>
</template>
<style lang="scss" scoped>
.status-badge {
	font-size: 11px;
	font-weight: $font-weight-medium;
	width: fit-content;
	height: $height-pill;
	background-color: white;
	border: $border-width-1 $border-style $color-neutral-300;
	padding: $spacing-1 $spacing-2;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: $border-radius-3;
	white-space: nowrap;

	&--success {
		color: $color-success-700;
		border-color: $color-success-400;
	}

	&--pending {
		color: $color-pending-600;
		border-color: $color-pending-300;
	}

	&--error {
		color: $color-error-600;
		border-color: $color-error-300;
	}

	&--warning {
		color: $color-warning-700;
		border-color: $color-warning-500;
	}

	&--default {
		color: $color-gray-600;
		border-color: $color-gray-300;
	}
}
</style>
